import React from 'react';
import { PublicNavBar } from './PublicNavBar';
import { PublicFooter } from './PublicFooter';
import { WhatsAppFAB } from './WhatsAppFAB';

export function PublicLayout({ children, heroPage = false }: { children: React.ReactNode; heroPage?: boolean }) {
  return (
    <div className="min-h-screen flex flex-col">
      <PublicNavBar />
      {/* Spacer for fixed navbar — skip on hero pages where content bleeds behind navbar */}
      {!heroPage && <div className="h-24" />}
      <main className="flex-1">{children}</main>
      <WhatsAppFAB />
      <PublicFooter />
    </div>
  );
}
